// removed by extract-text-webpack-plugin
module.exports = {"resettable-input":"resettable-input","is-button":"is-button","is-dropdown":"is-dropdown","dropdown-icon":"dropdown-icon","reset-button":"reset-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Inputs/ResettableInput.scss
// module id = zsuf
// module chunks = 0